export default `/* Ids Axis Chart Component */
.chart-legend {
  display: flex;
  padding-inline-start: 8px;
  flex-direction: row;
  margin-top: -4px;
  justify-content: flex-start;
  width: inherit;
}
.chart-legend a {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  align-items: center;
  border: 1px solid transparent;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-chart-legend-font-size);
  color: var(--ids-chart-legend-color-text);
  padding-inline-start: 8px;
  padding-inline-end: 8px;
  padding-block-start: 2px;
  padding-block-end: 2px;
  text-decoration: none;
}
.chart-legend a:focus {
  outline: none;
  border-color: var(--ids-color-border-focus);
  box-shadow: var(--ids-shadow-focus);
}
.chart-legend .swatch {
  display: inline-flex;
  margin-inline-end: 8px;
  height: 12px;
  width: 12px;
  pointer-events: none;
}
.chart-legend .swatch.color-1 {
  background-color: var(--ids-chart-color-1);
}
.chart-legend .swatch.color-2 {
  background-color: var(--ids-chart-color-2);
}
.chart-legend .swatch.color-3 {
  background-color: var(--ids-chart-color-3);
}
.chart-legend .swatch.color-4 {
  background-color: var(--ids-chart-color-4);
}
.chart-legend .swatch.color-5 {
  background-color: var(--ids-chart-color-5);
}
.chart-legend .swatch.color-6 {
  background-color: var(--ids-chart-color-6);
}
.chart-legend .swatch.color-7 {
  background-color: var(--ids-chart-color-7);
}
.chart-legend .swatch.color-8 {
  background-color: var(--ids-chart-color-8);
}
.chart-legend .swatch.color-9 {
  background-color: var(--ids-chart-color-9);
}
.chart-legend .swatch.color-10 {
  background-color: var(--ids-chart-color-10);
}
.chart-legend .swatch.color-11 {
  background-color: var(--ids-chart-color-11);
}
.chart-legend .swatch.color-12 {
  background-color: var(--ids-chart-color-12);
}
.chart-legend .swatch.color-13 {
  background-color: var(--ids-chart-color-13);
}
.chart-legend .swatch.color-14 {
  background-color: var(--ids-chart-color-14);
}
.chart-legend .swatch.color-15 {
  background-color: var(--ids-chart-color-15);
}
.chart-legend .swatch.color-16 {
  background-color: var(--ids-chart-color-16);
}
.chart-legend .swatch.color-17 {
  background-color: var(--ids-chart-color-17);
}
.chart-legend .swatch.color-18 {
  background-color: var(--ids-chart-color-18);
}
.chart-legend .swatch.color-19 {
  background-color: var(--ids-chart-color-19);
}
.chart-legend .swatch.color-20 {
  background-color: var(--ids-chart-color-20);
}
.chart-legend .swatch.color-21 {
  background-color: var(--ids-chart-color-21);
}

.ids-chart-container {
  display: flex;
  flex-direction: column;
}
.ids-chart-container.legend-top {
  margin-block-end: 8px;
  flex-direction: column-reverse;
}
.ids-chart-container.legend-top .chart-legend {
  margin-inline-start: 0;
  justify-content: end;
}
.ids-chart-container.legend-right, .ids-chart-container.legend-left {
  flex-direction: row;
}
.ids-chart-container.legend-right .chart-legend, .ids-chart-container.legend-left .chart-legend {
  margin-inline-start: 0;
  flex-direction: column;
  justify-content: center;
}
.ids-chart-container.legend-right .chart-legend a, .ids-chart-container.legend-left .chart-legend a {
  margin-block-end: 8px;
  width: max-content;
}
.ids-chart-container.legend-left {
  flex-direction: row-reverse;
}

.ids-axis-chart {
  display: flex;
}
.ids-axis-chart.hidden {
  display: none;
}
.ids-axis-chart title {
  pointer-events: none;
}
.ids-axis-chart .grid {
  shape-rendering: crispedges;
  stroke: var(--ids-axis-chart-grid-color);
  stroke-width: 1;
  stroke-dasharray: 2 2;
}
.ids-axis-chart .grid.horizontal-lines line.is-minimum {
  stroke: var(--ids-axis-chart-zero-line-color-border);
  stroke-dasharray: none;
}
.ids-axis-chart .grid.hidden {
  stroke-width: 0;
}
.ids-axis-chart.horizontal .grid.horizontal-lines line:last-child {
  stroke: inherit;
  stroke-dasharray: inherit;
}
.ids-axis-chart.horizontal .grid.vertical-lines line.is-minimum {
  stroke: var(--ids-axis-chart-zero-line-color-border);
  stroke-dasharray: none;
}
.ids-axis-chart g[tabindex="0"]:focus {
  outline: var(--ids-axis-chart-outline-focus);
}
.ids-axis-chart .labels {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-axis-chart-font-family);
  font-size: var(--ids-axis-chart-font-size);
}
.ids-axis-chart .labels text {
  fill: var(--ids-axis-chart-color-text);
}
.ids-axis-chart .labels.x-labels {
  text-anchor: middle;
}
.ids-axis-chart .labels.y-labels {
  text-anchor: end;
}
.ids-axis-chart .labels.axis-labels text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: var(--ids-axis-chart-font-weight);
  text-anchor: middle;
}
.ids-axis-chart .audible {
  opacity: 0;
}

.ids-chart-container.selectable .audible {
  font-size: 1px;
}
.ids-chart-container.full-height {
  height: 100%;
  overflow-y: hidden;
}
.ids-chart-container.full-height svg {
  flex-grow: 1;
}
.ids-chart-container.full-width {
  width: 100%;
  overflow-x: hidden;
}
.ids-chart-container:not([class*=legend-]) .chart-legend, .ids-chart-container.legend-none .chart-legend {
  display: none;
}

ids-empty-message:not([hidden]),
::slotted(ids-empty-message:not([hidden])) {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
ids-empty-message:not([hidden])[hidden],
::slotted(ids-empty-message:not([hidden]))[hidden] {
  display: none;
}

.tooltip-center {
  margin-block: var(--ids-space-2xs);
  text-align: center;
}

.tooltip.chart-legend {
  flex-direction: column;
  margin-block-end: var(--ids-space-xs);
  padding: 0;
  white-space: normal;
}
.tooltip.chart-legend .swatch {
  margin-inline: var(--ids-space-2xs);
  padding: 0;
}

.tooltip-row span {
  padding-inline-start: var(--ids-space-3xs);
  padding-inline-end: var(--ids-space-2xs);
}

:host([dir=rtl]) .ids-axis-chart {
  transform: scale(-1, 1);
}
:host([dir=rtl]) .ids-axis-chart:not(.horizontal) .labels.y-labels text {
  transform: scale(-1, 1) translate(var(--ids-axis-chart-ylabels-x, -45px), 0);
}
:host([dir=rtl]) .labels.x-labels {
  transform: scale(-1, 1);
  transform-origin: unset;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
